export enum ContactAddressType {
  Invoice = "INVOICE",
  DeliveryNote = "DELIVERY_NOTE",
  SafetyData = "SAFETY_DATA",
}
